import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { NavigationDropdownMenu } from './NavigationDropdownMenu';
import { NavigationDropdownToggle } from './NavigationDropdownToggle';
import useNavigation from '../hooks/useNavigation';
import { NavigationDropdownProps } from '../types';

export function NavigationDropdown({ title, align = 'end', ...props }: NavigationDropdownProps) {
	const [show, setShow] = React.useState(false);
	const { show: navbarShow } = useNavigation();

	React.useEffect(() => {
		if (!navbarShow) {
			// ensure dropdowns are closed when main nav is closed
			setShow(false);
		}
	}, [navbarShow]);

	return (
		<Dropdown as="li" className="nav-item" show={show} onToggle={nextShow => setShow(nextShow)}>
			<Dropdown.Toggle as={NavigationDropdownToggle}>{title}</Dropdown.Toggle>
			<Dropdown.Menu as={NavigationDropdownMenu} align={align} {...props} />
		</Dropdown>
	);
}
